/* eslint-disable no-restricted-imports */

import { DS_HEIGHT } from '@calm/evexia-design-tokens';
import {
    Avatar as OgAvatar,
    AvatarProps as OgAvatarProps,
} from '@mui/material';
import { useMemo } from 'react';
import { sxAppend } from '../../sx';

export type AvatarProps = OgAvatarProps & {
    size?: 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge';
};
export const Avatar = ({ size, ...props }: AvatarProps) => {
    const sizePx = useMemo(() => {
        switch (size) {
            case 'xxlarge':
                return DS_HEIGHT.AVATAR_XXLARGE;
            case 'xlarge':
                return DS_HEIGHT.AVATAR_XLARGE;
            case 'large':
                return DS_HEIGHT.AVATAR_LARGE;
            case 'medium':
                return DS_HEIGHT.AVATAR_MEDIUM;
            default:
                return DS_HEIGHT.AVATAR_SMALL;
        }
    }, [size]);
    return (
        <OgAvatar
            {...props}
            sx={sxAppend(
                {
                    fontSize: sizePx / 2,
                    height: sizePx,
                    width: sizePx,
                },
                props.sx
            )}
        />
    );
};
